import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';

class DropDownMulipleUse extends React.Component {

  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  focus() {
    if (this.select) {
      this.select.focus();
    }
  }

  render() {
    return (
      <DropDown disabled={this.props.disable} onRef={select => (this.select = select)} label={this.props.label } confirm={this.props.confirm} bindValidator={this} channel={this.props.channel} require={this.props.require} selectedValue={this.props.selectedValue} options={ this.props.data } keyName={ this.props.keyName } valueName={this.props.valueName} className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } name={this.props.name}/>
    );
  }
}

DropDownMulipleUse.defaultProps = {
  label: 'Text label',
  disable: false,
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  onRef: function() {
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  keyName: '',
  valueName: '',
  channel: 'formTaoDon',
  options: [],
  data: [],
  name: ''
}


export default validatable(DropDownMulipleUse);


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownMulipleUse.jsx